export default "__VITE_ASSET__C8l22DQg__"